/**
 * Filtra grid de coleção para exibir apenas produtos com entrega expressa no CEP informado.
 * Ativo quando a URL contém ?express=1 (ex.: redirect do aviso de carrinho).
 *
 * Anti-flicker: o grid é ocultado o quanto antes (classe no <html>, definida também
 * inline no <head>). Os cards nascem invisíveis e só os disponíveis são revelados,
 * evitando o efeito de "verificar produtos" aparecendo/sumindo um a um.
 */
(function () {
  if (window.__haomaExpressCollectionFilterInit) return;
  window.__haomaExpressCollectionFilterInit = true;

  var QUERY_PARAM = 'express';
  var SESSION_KEY = 'haoma-express-collection-filter';
  var HTML_HIDE_CLASS = 'haoma-express-hide-grid';
  var GRID_FILTER_CLASS = 'haoma-express-filtering';
  var BANNER_ID = 'haoma-express-collection-banner';
  var EMPTY_ID = 'haoma-express-collection-empty';
  var debounceTimer = null;

  function isCollectionPage() {
    return document.body.classList.contains('theme-template-collection')
      || window.location.pathname.indexOf('/collections/') === 0;
  }

  function isFullPageNavigate() {
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      return !nav || nav.type === 'navigate';
    } catch (e) {
      return true;
    }
  }

  function isExpressFilterActive() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get(QUERY_PARAM) === '1') {
        sessionStorage.setItem(SESSION_KEY, '1');
        return true;
      }
    } catch (e) {
      if (window.location.search.indexOf(QUERY_PARAM + '=1') >= 0) {
        try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (err) {}
        return true;
      }
    }

    // Link limpo (ex.: botão Ver da home) encerra o modo express —
    // não reanexa ?express=1 via sessionStorage.
    if (isCollectionPage() && isFullPageNavigate()) {
      try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
      return false;
    }

    try {
      return sessionStorage.getItem(SESSION_KEY) === '1' && isCollectionPage();
    } catch (e) {
      return false;
    }
  }

  // Aplica o estado de ocultação imediatamente (síncrono). O CSS no <head> usa
  // a classe do <html> para esconder cards ainda não confirmados.
  function markFilteringState() {
    document.documentElement.classList.add(HTML_HIDE_CLASS);
    var grid = document.getElementById('items-grid');
    if (grid) grid.classList.add(GRID_FILTER_CLASS);
  }

  function persistExpressFilterInUrl() {
    if (!isCollectionPage()) return;
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get(QUERY_PARAM) === '1') return;
      if (sessionStorage.getItem(SESSION_KEY) !== '1') return;
      url.searchParams.set(QUERY_PARAM, '1');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (e) {
      /* ignore */
    }
  }

  function parseSkus(value) {
    return String(value || '')
      .split(',')
      .map(function (sku) { return sku.trim(); })
      .filter(Boolean);
  }

  function uniqueSkus(list) {
    var set = {};
    list.forEach(function (sku) { set[sku] = true; });
    return Object.keys(set);
  }

  function getSavedCep() {
    try {
      var raw = localStorage.getItem('haoma-cep-express');
      if (!raw) return '';
      var data = JSON.parse(raw);
      return data && data.cep ? String(data.cep) : '';
    } catch (e) {
      return '';
    }
  }

  function getGridItems() {
    var grid = document.getElementById('items-grid');
    if (!grid) return [];
    return Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid-item'));
  }

  function revealItem(item) {
    item.hidden = false;
    item.classList.remove('express-filter-hidden');
    item.classList.add('express-filter-visible');
  }

  function hideItem(item) {
    item.hidden = true;
    item.classList.remove('express-filter-visible');
    item.classList.add('express-filter-hidden');
  }

  function ensureBanner(message, showCepButton) {
    var existing = document.getElementById(BANNER_ID);
    if (existing) {
      // Só reescreve quando o texto muda: atribuir textContent recria o nó de
      // texto e o MutationObserver do grid reagendaria o filtro sem parar.
      var text = existing.querySelector('.haoma-express-collection-banner__text');
      if (text && text.textContent !== message) text.textContent = message;
      var btn = existing.querySelector('.haoma-express-collection-banner__btn');
      if (btn) btn.hidden = !showCepButton;
      return existing;
    }

    var grid = document.getElementById('items-grid');
    if (!grid || !grid.parentNode) return null;

    var banner = document.createElement('div');
    banner.id = BANNER_ID;
    banner.className = 'haoma-express-collection-banner';
    banner.innerHTML =
      '<p class="haoma-express-collection-banner__text"></p>' +
      '<button type="button" class="haoma-express-collection-banner__btn" hidden>Informar CEP</button>';
    banner.querySelector('.haoma-express-collection-banner__text').textContent = message;

    if (showCepButton) {
      var button = banner.querySelector('.haoma-express-collection-banner__btn');
      button.hidden = false;
      button.addEventListener('click', function () {
        window.dispatchEvent(new CustomEvent('haoma:open-cep-popup'));
      });
    }

    grid.parentNode.insertBefore(banner, grid);
    return banner;
  }

  function ensureEmptyState(message) {
    var existing = document.getElementById(EMPTY_ID);
    if (existing) {
      if (existing.textContent !== message) existing.textContent = message;
      existing.hidden = false;
      return existing;
    }

    var grid = document.getElementById('items-grid');
    if (!grid) return null;

    var empty = document.createElement('p');
    empty.id = EMPTY_ID;
    empty.className = 'haoma-express-collection-empty';
    empty.textContent = message;
    grid.parentNode.insertBefore(empty, grid.nextSibling);
    return empty;
  }

  function isInjectedNode(node) {
    var el = node && node.nodeType === 1 ? node : node && node.parentNode;
    if (!el || typeof el.closest !== 'function') return false;
    return !!el.closest('#' + BANNER_ID + ', #' + EMPTY_ID);
  }

  function hideEmptyState() {
    var empty = document.getElementById(EMPTY_ID);
    if (empty) empty.hidden = true;
  }

  async function filterGrid() {
    if (!isCollectionPage() || !isExpressFilterActive()) return;

    // Garante ocultação antes de qualquer verificação assíncrona.
    markFilteringState();

    var items = getGridItems();
    if (!items.length) return;

    var cep = getSavedCep();
    if (!cep) {
      ensureBanner(
        'Informe seu CEP para ver apenas produtos disponíveis para entrega expressa na sua região.',
        true
      );
      items.forEach(hideItem);
      ensureEmptyState('Nenhum produto exibido. Informe seu CEP para continuar.');
      return;
    }

    ensureBanner(
      'Mostrando apenas produtos disponíveis para entrega expressa na sua região.',
      false
    );

    var entries = [];
    items.forEach(function (item) {
      var badge = item.querySelector('[data-express-sku]');
      if (!badge) {
        hideItem(item);
        return;
      }
      entries.push({ item: item, badge: badge });
    });

    if (!entries.length) {
      ensureEmptyState('Nenhum produto com entrega expressa disponível para o seu CEP nesta coleção.');
      return;
    }

    var allSkus = [];
    entries.forEach(function (entry) {
      parseSkus(entry.badge.getAttribute('data-express-sku')).forEach(function (sku) {
        allSkus.push(sku);
      });
    });

    var map = {};
    if (window.haomaExpressAvailability && typeof window.haomaExpressAvailability.check === 'function') {
      map = await window.haomaExpressAvailability.check(uniqueSkus(allSkus));
    }

    var visibleCount = 0;
    entries.forEach(function (entry) {
      var skus = parseSkus(entry.badge.getAttribute('data-express-sku'));
      var isAvailable = skus.some(function (sku) { return map[sku] === true; });

      if (isAvailable) {
        revealItem(entry.item);
        visibleCount += 1;
      } else {
        hideItem(entry.item);
      }
    });

    if (visibleCount === 0) {
      ensureEmptyState('Nenhum produto com entrega expressa disponível para o seu CEP nesta coleção.');
    } else {
      hideEmptyState();
    }
  }

  function scheduleFilter() {
    // Reaplica o estado de ocultação já, para que cards recém-inseridos
    // pela paginação/facets nasçam invisíveis e não pisquem.
    if (isExpressFilterActive()) markFilteringState();
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      persistExpressFilterInUrl();
      filterGrid().then(function () {
        initObserver();
      });
    }, 120);
  }

  function initObserver() {
    if (!window.MutationObserver || !isExpressFilterActive()) return;

    if (window.__haomaExpressCollectionObserver) {
      window.__haomaExpressCollectionObserver.disconnect();
    }

    var container = document.getElementById('ProductGridContainer') || document.getElementById('items-grid');
    if (!container) return;

    var observer = new MutationObserver(function (mutations) {
      // Mutações dos próprios elementos injetados aqui (banner / estado vazio)
      // não devem reagendar o filtro, senão o observer se auto-alimenta.
      var relevant = mutations.some(function (mutation) {
        return !isInjectedNode(mutation.target);
      });
      if (!relevant) return;

      // Oculta imediatamente qualquer card novo antes do debounce.
      if (isExpressFilterActive()) markFilteringState();
      scheduleFilter();
    });

    observer.observe(container, { childList: true, subtree: true });
    window.__haomaExpressCollectionObserver = observer;
  }

  function boot() {
    if (!isCollectionPage() || !isExpressFilterActive()) return;

    markFilteringState();
    persistExpressFilterInUrl();
    filterGrid().then(function () {
      initObserver();
    });

    window.addEventListener('haoma:cep-updated', scheduleFilter);
  }

  // Aplica ocultação o quanto antes, mesmo antes do DOMContentLoaded.
  if (isCollectionPage() && isExpressFilterActive()) {
    markFilteringState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.haomaExpressCollectionFilter = {
    refresh: scheduleFilter,
    isActive: isExpressFilterActive
  };
})();
